module.exports = __webpack_public_path__ + "img/banner.ac8fe781.png";